import { postWithPopulationIdHeader } from './serviceBase';

const baseUrl = '/api/v1.0/StockDataQuality';

export function setInventoryMethod(populationId, inventoryMethod, successCallback, errorCallback) {
    const url = `${baseUrl}/SetInventoryMethod`;
    postWithPopulationIdHeader(url, populationId, inventoryMethod, successCallback, errorCallback);
}
